import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client';
import gql from 'graphql-tag';

type Result = { getStudentResumeById: string };
type Variables = { userId: number };

export function useGetStudentResumeById(options?: LazyQueryHookOptions<Result, Variables>) {
  const getStudentResumeByIdQuery = gql`
    query getStudentResumeById($userId: Int!) {
      getStudentResumeById(userId: $userId)
    }
  `;

  return useLazyQuery<Result, Variables>(getStudentResumeByIdQuery, {
    // Always fetch fresh data from the network and don't cache results
    // This prevents cache conflicts since document generation is always unique
    fetchPolicy: 'no-cache',
    ...options
  });
}
